import { render, staticRenderFns } from "./customerSet.vue?vue&type=template&id=a863598c&scoped=true"
import script from "./customerSet.vue?vue&type=script&lang=js"
export * from "./customerSet.vue?vue&type=script&lang=js"
import style0 from "./customerSet.vue?vue&type=style&index=0&id=a863598c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863598c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a863598c')) {
      api.createRecord('a863598c', component.options)
    } else {
      api.reload('a863598c', component.options)
    }
    module.hot.accept("./customerSet.vue?vue&type=template&id=a863598c&scoped=true", function () {
      api.rerender('a863598c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serviceCenter/workBench/components/customerSet.vue"
export default component.exports